import Authentication from '@/utilities/auth/Authentication'
import AxiosService from '@/utilities/service/AxiosService'
import VueJwtDecode from 'vue-jwt-decode'
import axios from '@/utilities/service/httpClient'
import Api from '@/api'

const api = new Api()

export default {
  async azure({ commit }, azure) {
    const auth = new Authentication(azure, VueJwtDecode)
    const axiosService = new AxiosService(axios, VueJwtDecode)
    auth.azureLogin(commit, window.$cookies)

    axiosService.setAuthorization(auth)

    try {
      return await api.auth().login()
    } catch (e) {
      commit('auth_error')
      commit(
        'Dashboard/setFeedback',
        {
          message: 'Bad credentials, please verify that your username/password are correctly set',
          errors: 401,
        },
        { root: true },
      )
      delete axios.defaults.headers.common.Authorization
    }
  },
  logout({ commit }) {
    localStorage.clear()
    commit('logout')
    commit('SET_TOKEN', null)
    commit('SET_USER', null)
    const keyCookies = ['user', 'email']
    keyCookies.forEach(key => (window.$cookies.isKey(key) ? window.$cookies.remove(key) : null))
    delete axios.defaults.headers.common.Authorization
  },
  fetchUser({ commit }) {
    const user = window.$cookies.get('user')
    commit('SET_USER', user)
  },
}
